/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import IFormConfiguration from 'apmui/components/form/Model';
import ITemplateModel from 'apmui/master/Model';
import PageType from 'apmui/page/PageType';

const FORM_ID = 'auth_form';
const RECAPTCHA_FIELD_NAME = 'g-recaptcha-response';

interface IReCaptchaModel {
    config?: {
        siteKey: string;
        theme: string;
        type: string;
        size: string;
        challengeUrl: string;
        noscriptUrl: string;
        version: string;
    };
    errorMessage?: string;
}

enum CHALLENGE {
    NORMAL = 'normal',
    ERROR = 'error',
    PIN_CHANGE = 'pin_change',
    NEW_PASSWORD = 'new_password',
    SOFT_TOKEN = 'soft_token',
    CITRIX_RECEIVER = 'citrix_receiver',
}

interface IChallengeModel {
    status: CHALLENGE;
    message: string;
}

interface IRetryModel {
    message: string;
}

interface ISoftTokenModel {
    fieldName: string;
    state: string;
    newPIN: string;
    message?: string;
}

/**
 * Configuration data specific to Logon Page agent
 */
interface ILogonPageModel extends ITemplateModel {
    pageType: PageType.LOGON;
    [PageType.LOGON]: {
        /*
         * See that config is changing based on what lp is displaying atm
         * TODO / Idea may be explicit variable
         */
        recaptcha?: IReCaptchaModel;
        challenge?: IChallengeModel;
        retry?: IRetryModel;
        original?: {
            logonOriginalUrl: string;
        };
        softToken: ISoftTokenModel;
        /* Form configuration */
        form: IFormConfiguration;
        images: {
            frontImage: string;
        };
        customMessage?: string;
    };
}

export {
    ILogonPageModel as default,
    ILogonPageModel,
    FORM_ID,
    IReCaptchaModel,
    RECAPTCHA_FIELD_NAME,
    CHALLENGE,
    IChallengeModel,
    IRetryModel,
};
